import { Component, OnInit } from '@angular/core';
import { RuleEngineAuthService } from '../../services/rule-engine-auth.service';
import { RuleEngineCoreService } from '../../services/rule-engine-core.service';

@Component({
  selector: 'app-rule-engine-test',
  template: `
    <div style="padding: 40px; max-width: 1200px; margin: 0 auto;">
      <h2>🧪 RuleEngine Authentication Test</h2>
      
      <div style="margin: 20px 0;">
        <button (click)="testAuth()" style="margin-right: 10px; padding: 10px 20px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Test Auth Token
        </button>
        
        <button (click)="testGetRules()" style="margin-right: 10px; padding: 10px 20px; background: #2196F3; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Test GET Rules
        </button>
        
        <button (click)="testGetRuleTypes()" style="margin-right: 10px; padding: 10px 20px; background: #FF9800; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Test GET Rule Types
        </button>

        <button (click)="testHealth()" style="padding: 10px 20px; background: #9C27B0; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Test Health
        </button>
      </div>

      <div *ngIf="loading" style="margin: 20px 0; padding: 20px; background: #FFF3CD; border: 1px solid #FFE69C; border-radius: 4px;">
        ⏳ Loading...
      </div>

      <div *ngIf="error" style="margin: 20px 0; padding: 20px; background: #F8D7DA; border: 1px solid #F5C6CB; border-radius: 4px;">
        <strong>❌ Error:</strong>
        <pre style="margin-top: 10px; white-space: pre-wrap;">{{ error }}</pre>
      </div>

      <div *ngIf="result" style="margin: 20px 0; padding: 20px; background: #D4EDDA; border: 1px solid #C3E6CB; border-radius: 4px;">
        <strong>✅ Success:</strong>
        <pre style="margin-top: 10px; white-space: pre-wrap; max-height: 400px; overflow: auto;">{{ result }}</pre>
      </div>
    </div>
  `,
  styles: [`
    pre {
      font-family: 'Courier New', monospace;
      font-size: 12px;
      line-height: 1.4;
    }
    
    button:hover {
      opacity: 0.9;
    }
    
    button:active {
      transform: translateY(1px);
    }
  `]
})
export class RuleEngineTestComponent implements OnInit {
  loading = false;
  error: string | null = null;
  result: string | null = null;

  constructor(
    private authService: RuleEngineAuthService,
    private ruleEngineService: RuleEngineCoreService
  ) {}

  ngOnInit() {
    console.log('RuleEngineTestComponent initialized');
  }

  testAuth() {
    this.loading = true;
    this.error = null;
    this.result = null;

    this.authService.getToken().subscribe({
      next: (token) => {
        this.loading = false;
        this.result = JSON.stringify({
          status: 'Token obtained successfully',
          token: token.substring(0, 100) + '...',
          length: token.length
        }, null, 2);
      },
      error: (err) => {
        this.loading = false;
        this.error = JSON.stringify({
          message: err.message,
          status: err.status,
          error: err.error
        }, null, 2);
      }
    });
  }

  testGetRules() {
    this.loading = true;
    this.error = null;
    this.result = null;

    const tenant = 'DEMO';
    const customerId = '1';

    this.ruleEngineService.getRules(tenant, customerId).subscribe({
      next: (rules) => {
        this.loading = false;
        this.result = JSON.stringify({
          status: 'Rules fetched successfully',
          tenant: tenant,
          customerId: customerId,
          count: rules.length,
          rules: rules
        }, null, 2);
      },
      error: (err) => {
        this.loading = false;
        this.error = JSON.stringify({
          message: err.message,
          status: err.status,
          error: err.error
        }, null, 2);
      }
    });
  }

  testGetRuleTypes() {
    this.loading = true;
    this.error = null;
    this.result = null;

    this.ruleEngineService.getRuleTypes().subscribe({
      next: (types) => {
        this.loading = false;
        this.result = JSON.stringify({
          status: 'Rule types fetched successfully',
          count: types.length,
          types: types
        }, null, 2);
      },
      error: (err) => {
        this.loading = false;
        this.error = JSON.stringify({
          message: err.message,
          status: err.status,
          error: err.error
        }, null, 2);
      }
    });
  }

  testHealth() {
    this.loading = true;
    this.error = null;
    this.result = null;

    this.ruleEngineService.getHealth().subscribe({
      next: (health) => {
        this.loading = false;
        this.result = JSON.stringify({
          status: 'Health check successful',
          health: health
        }, null, 2);
      },
      error: (err) => {
        this.loading = false;
        this.error = JSON.stringify({
          message: err.message,
          status: err.status,
          error: err.error
        }, null, 2);
      }
    });
  }
}
